import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HeaderHelperService } from '../header-helper.service';
import { Observable } from 'rxjs';
import { EditSystemInformationRequest, GetSystemInformationRequest, SystemInformationModel } from '../../models/systemInformation/system-information.model';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SystemInformationService {

   constructor(
      private http: HttpClient,
      private headerHelperService: HeaderHelperService
    ) {}
  
    getSystemInformation(): Observable<SystemInformationModel[]> {
      return this.http.get<SystemInformationModel[]>(
        `${environment.apiLocations.patient}/SystemInformation`,
        {
          headers: this.headerHelperService.getHeaders(),
        }
      );
    }
}
